import { DocumentType } from '../../../enums/document-type';
import Global from '../../global-selectors';
import { packingSlip } from '../document-type-epic-helpers/packing-slip';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @param {object} args
 * @param {string[]} args.fulfillmentPlanIds
 * @param {() => object} args.getState - redux getState function
 * @param {string | number} [args.templateId]
 * @param {object} [args.printer] - if you're not printing, but doing something like downloading this can be omitted
 * @param {number} [args.pusherTimeoutMs]
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const createPackingSlipsAsync = ({ fulfillmentPlanIds, getState, templateId, printer, pusherTimeoutMs }) => {
  const documentCount = fulfillmentPlanIds.length;

  const notification = packingSlip.getAsyncPrintStartedNotificationProps(documentCount);
  const errorNotification = packingSlip.getAsyncPrintFailedNotificationProps(documentCount);

  const selectedFormat = Global.selectPrintPrintDocumentFormat(getState());
  const selectedTemplateId = templateId || selectedFormat?.packingSlipId;

  return jobRunner({
    apiRequest: () => Api.generatePackingSlipAsync(fulfillmentPlanIds, selectedTemplateId),
    documentCount,
    documentTypeIdentifier: DocumentType.PackingSlip.identifier,
    initialNotification: notification,
    errorNotification,
    ids: fulfillmentPlanIds,
    printer,
    pusherTimeoutMs,
  });
};
